module.exports = __webpack_public_path__ + "static/media/8.0d34e0c1.jpg";